<template>
<section v-if="history.length > 0" class="history pcOnly">
  <div class="history__container">
    <h2 class="shopCommonInfo__title">最近見たお店</h2>
    <div class="ui five cards">
      <a class="ui card" v-for="shop in shops" :key="shop.id" :href="shop.detail_url" target="_blank">
        <div class="image">
            <img :src="shop.main_image.urls.medium_square" :alt="shop.name + '+宴会パーティ'">
        </div>
        <div class="content">
          <div class="header">{{ shop.name }}</div>
          <div class="description">
            <span v-for="genre in shop.genre_labels">{{ genre.label }}</span>
          </div>
          <div class="extra">
            <div v-if="shop.max_standing_count || shop.max_count">立席：{{ shop.max_standing_count || '--' }}人 着席：{{ shop.max_count || '--' }}人 まで</div>
            <div v-if="shop.lowest_price">{{ shop.lowest_price }}円〜</div>
          </div>
        </div>
      </a>
    </div>
  </div>
</section>
</template>

<script>
export default {
  props: {
    history: {
      required: true,
      type: Array
    }
  },
  data: function() {
    return {
      shops: []
    };
  },
  created: function() {
    var promises = this.history.slice(0, 5).map(function(shop_id) {
      return this.createForm().get('/api/shops/' + shop_id);
    }.bind(this));

    Promise.all(promises).then(function(responses) {
      this.shops = responses.map(function(response) {
        return response.data;
      });
    }.bind(this));
  }
};
</script>
